export { uploadBase64Images } from '../_internal/clients/uploadBase64Images';